<template>
<v-container
  fluid
  grid-list-md
>
<v-layout row wrap>
  <v-flex xs12>
    <ListPersons :persons="persons" :sort-by="null">

      <h2>Клиенты</h2>

      <div class="px-3"></div>

      <v-autocomplete
      class="mx-2" dense
      label="школа"
      :items="schools"
      v-model="school"
      :search-input.sync="searchSchools"
      return-object item-text="name" clearable hide-details
      @input="fetchPersons()"
      ></v-autocomplete>

      <v-autocomplete
      class="mx-2" dense
      label="класс"
      :items="positions"
      v-model="position"
      :search-input.sync="searchPositions"
      return-object item-text="name" clearable hide-details
      @input="fetchPersons()"
      ></v-autocomplete>
      <v-flex xs1>
      </v-flex>

      <v-select
      class="mx-2" dense
      label="зарегистрированные" v-model="isclient"
      :items="[{ text: 'только они', value: true }, { text: 'без них', value: false }]"
      @change="fetchPersons()"
      clearable
      hide-details
      ></v-select>

      <v-select
      class="mx-2" dense
      label="ученики" v-model="arestudents"
      :items="[{ text: 'только они', value: true }, { text: 'без них', value: false }]"
      @change="fetchPersons()"
      clearable
      hide-details
      ></v-select>

      <v-select
      class="mx-2" dense
      label="архивные" v-model="isarchived"
      :items="[{ text: 'только они', value: true }, { text: 'без них', value: false }]"
      @change="fetchPersons()"
      clearable
      hide-details
      ></v-select>

      <v-select
      class="mx-2" dense
      label="без привязки к школе" v-model="iswithoutschool"
      :items="[{ text: 'только они', value: true }, { text: 'без них', value: false }]"
      @change="fetchPersons()"
      clearable
      hide-details
      ></v-select>

      <v-dialog
        v-model="dialogNewPerson"
        persistent modal
        width="500"
        transition="dialog-transition"
        v-if="isoperator"
      >
        <template v-slot:activator="{ on }">
          <v-btn icon small
          v-on="on"
          :disabled="isoperator === false" color="secondary"
          >
            <v-icon>add</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-card-title class="headline">
            Новый пользователь
            <v-spacer></v-spacer>
            <v-btn icon small @click="dialogNewPerson=false;newPersonFullname=null"><v-icon>close</v-icon></v-btn>
          </v-card-title>
          <v-card-text>
            <br>
            <v-text-field
            v-model="newPersonFullname"
            label="ФИО"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
            text
            @click="dialogNewPerson=false;newPersonFullname=null"
            >Отмена</v-btn>
            <v-btn
              color="primary" text
              :disabled="!newPersonFullname || newPersonFullname.length<4"
              @click="addNewPerson()"
              >
              Добавить пользователя
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </ListPersons>
  </v-flex>
</v-layout>
</v-container>
</template>

<script>
import ListPersons from '@/components/ListPersons.vue'
export default {
  name: 'Persons',
  components: { ListPersons },
  data: () => ({
    persons: [],
    headers: [
      { text: 'id', value: 'personid', sortable: false },
      { text: 'фио', value: 'fullname', },
      { text: 'карта', value: 'cardid', },
      { text: 'школа', value: 'schoolname', },
      { text: 'класс', value: 'positionname', },
      { text: 'телефон', value: 'phone', },
      { text: 'имейл', value: 'email', },
      { text: 'ученик?', value: 'arestudents', },
      { text: 'архивный?', value: 'isarchived', },
      { text: 'группы', value: 'groups', sortable: false },
    ],
    isclient: null,
    isarchived: null,
    iswithoutschool: null,
    arestudents: null,
    school: null,
    schools: [],
    position: null,
    positions: [],
    searchSchools: null,
    searchPositions: null,

    dialogNewPerson: false,
    newPersonFullname: null,
  }),
  computed: {
    profile () {
      return this.$store.state.profile
    },
    search () {
      return this.$store.state.search
    },
    scopes () {
      return this.profile ? this.profile.scopes : []
    },
    isadmin () {
      return this.scopes.includes('admin')
    },
    isoperator () {
      return this.scopes.includes('operator')
    },
  },
  methods: {
    async fetchPersons () {
      try {
        const { meta, persons } = await this.$store.dispatch('sioRequest', {
          topic: 'search-persons',
          pl: {
            q: this.search && this.search.length > 2 ? this.search : null,
            schoolid: this.school ? this.school.schoolid : null,
            positionid: this.position ? this.position.positionid : null,
            limit: 200,
            isclient: this.isclient,
            archived: this.isarchived,
            iswithoutschool: this.iswithoutschool,
            arestudents: this.arestudents,
          }
        })
        this.persons = persons
        return persons
      } catch (e) {
        this.$store.dispatch('snack', e)
      }
    },
    async fetchSchools () {
      if (this.schools.length > 0) return this.schools
      try {
        const { meta, schools } = await this.$store.dispatch('sioRequest', {
          topic: 'fetch-schools'
        })
        this.schools = schools
        return schools
      } catch (e) {
        this.$store.dispatch('snack', e)
      } finally {
        this.fetchPositions()
      }
    },
    async fetchPositions () {
      if (!this.school) return []
      try {
        const { meta, positions } = await this.$store.dispatch('sioRequest', {
          topic: 'filter-positions',
          pl: {
            schoolid: this.school.schoolid
          }
        })
        this.positions = positions
        return positions
      } catch (e) {
        this.$store.dispatch('snack', e)
      }
    },
    fetch () {
      this.fetchSchools()
      this.fetchPositions()
      this.fetchPersons()
    },
    async addNewPerson () {
      try {
        await this.$store.dispatch('confirm', `Продолжить создание нового пользователя с именем ${this.newPersonFullname}?`)
        const { meta, person } = await this.$store.dispatch('sioRequest', {
          topic: 'add-person',
          pl: { fullname: this.newPersonFullname }
        })
        this.dialogNewPerson = false
        this.newPersonFullname = null
        this.$store.dispatch('snack', meta)
        this.$router.push({ name: 'person', params: { personid: person.personid } })
      } catch (e) {
        this.$store.dispatch('snack', e)
      }
    }
  },
  watch: {
    profile (val) {
      if (val) this.fetch()
    },
    search (val) {
      this.fetch()
    },
    searchSchools (val) {
      if (val) {
        this.fetch()
      } else {
        this.positions = []
        this.position = null
      }
    },
    searchPositions (val) {
      if (val) this.fetchPersons()
    },
  },
  async mounted () {
    if (this.profile) await this.fetch()
  },
}
</script>

<style lang="css">
</style>
